module.exports = __webpack_public_path__ + "media/videos/term-bg-1-95d056f5.jpg";